import { Professional, User } from '@abiglobalhealth/go-types'
import { isAxiosError } from 'axios'
import { TOptions } from 'i18next'

import { updateUserLanguage } from '@/api/user'
import { getStoredConfig } from '@/utils/config'

import i18n from './i18n'

export const getApiKey = () => {
  return window.location.pathname.split('/')[1]
}

export const getTranslationKey = () => {
  const config = getStoredConfig()
  return config?.translationKey?.trim() || getApiKey() || undefined
}

export const getSlugTranslationKeys = (phraseKey: string) => {
  const translationKey = getTranslationKey()
  return translationKey ? [`${phraseKey}.${translationKey}`, phraseKey] : [phraseKey]
}

export const getSlugTranslation = (phraseKey: string, options?: TOptions) => i18n.t(getSlugTranslationKeys(phraseKey), options || {})

export const getProfessionalKey = (professional: Professional) => [
  `${professional.title}_title_${professional.gender}`,
  `person_title_${professional.gender}`
]

const updateTranslations = async (language: string | undefined) => {
  if (language && language !== i18n.language) await i18n.changeLanguage(language)
  handleRTLLanguage(i18n.language)
  return language
}

export const handleUserLanguage = async (user: User | null): Promise<string | undefined> => {
  const queryParamLanguage = new URLSearchParams(window.location.search).get('language')
  const userLanguage = user?.data?.language

  if (userLanguage && queryParamLanguage && queryParamLanguage !== userLanguage) {
    try {
      const updatedUser = await updateUserLanguage({ userId: user.data.userId!, language: queryParamLanguage })
      return await updateTranslations(updatedUser.data.language)
    } catch (e) {
      if (isAxiosError(e) && e.response?.status === 401) {
        console.error(`User language ${queryParamLanguage} is not allowed`)
        return await updateTranslations(userLanguage)
      }
      throw e
    }
  }

  return await updateTranslations(userLanguage || queryParamLanguage || undefined)
}

const RTL_LANGUAGES = ['ar_ae', 'ar_lb']
export const isRTL = (language?: string) => RTL_LANGUAGES.includes(language || i18n.language)

const handleRTLLanguage = (language: string) => (document.documentElement.dir = isRTL(language) ? 'rtl' : 'ltr')
